APP.Login = (/** @lends APP.Login */function () {
	'use strict';

	var exports,
		$body,
		$loginPopUpTemplate,
		$smsLoopContainer,
		$iframeReloadBtn,
		$smsLoopActiveText,
		iframeSrc,
		$desktopLoginContainer;

	function init() {

		initDOMElements();
		initBindings();
	}

	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
		$loginPopUpTemplate = APP.Template.get('login-popup');
		$smsLoopContainer = $body.find('[data-sms-loop]');
		$iframeReloadBtn = $body.find('[data-iframe-reload]');
		$smsLoopActiveText = $body.find('[data-smsloop-active-text]');
		iframeSrc = $body.find('[data-smsloop-iframe]').attr('src');

		$desktopLoginContainer = $body.find('[data-ref~="home-login-section"]');
		if ($desktopLoginContainer.length > 0) {
			$desktopLoginContainer.find('[data-ref~="login-panel"]').html($loginPopUpTemplate({loginState: '1'}));
			APP.Tooltip.updateWithin($desktopLoginContainer);
		}
	}

	function initBindings() {

		$body.on('click.open-overlay', '[data-open-loginpopup]', function (e) {
			e.preventDefault();
			if (APP.Maintenance.isLoginDisabled() === true) {
				APP.Maintenance.showDisabledLoginLayer();
			} else {
				APP.Login.open({
					loginState: $(this).attr('data-open-loginpopup')
				});
			}

		});

		window.addEventListener('message', function (event) {
			var msgId;

			if (event.data && event.data.split && event.data.split(':')[0] === 'page') {
				msgId = event.data.split(':')[1];
				if (msgId === 'wait-for-code') {
					smsHookPosted(event.data.split(':')[3]);
				} else {
					change1TpLabel(msgId);
				}
			}
		}, false);

		$iframeReloadBtn.on({
			click: function (e) {
				reloadIframe();
				e.preventDefault();
			}
		});

		$body.on('submit', '[data-login-form]', function() {
			APP.Analytics.setStickyTrack('Belepes', null, 'Email', null);
		});

	}

	function showReloadButton() {
		$iframeReloadBtn.show();
	}

	function hideReloadButton() {
		$iframeReloadBtn.hide();
	}

	function reloadIframe() {
		display1TpError('');
		$smsLoopContainer.attr('data-sms-loop', 'false');
		$body.find('[data-smsloop-iframe]').attr('src', iframeSrc);
		$smsLoopActiveText.addClass('block--display-none');
		$body.find('[data-smsloop-iframe]').css('height', 'auto');
		hideReloadButton();
	}

	function open(data) {
		var _data;

		if (typeof data === 'undefined' || typeof data.loginState === 'undefined') {
			_data = {
				loginState: 1
			};
		} else {
			_data = data;
		}

		APP.Overlay.setContent($loginPopUpTemplate(_data), true, true);
		APP.Overlay.open();
	}

	function display1TpError(error) {
		$body.find('[data-element="1tp-error"]').html(error);
	}

	function change1TpLabel(page) {
		$body.find('[data-element^="1tp-label"]').hide();
		$body.find('[data-element="1tp-label:' + page + '"]').show();
	}

	function smsHookPosted(sessionId) {
		loadSmsLoop(sessionId);
	}

	function loadSmsLoop(sessionId) {
		$smsLoopContainer.attr('data-sms-loop', 'active');
		$smsLoopActiveText.removeClass('block--display-none');
		$body.find('[data-smsloop-iframe]').css('height', 0);
		showReloadButton();
		APP.Service.post({
			session_id: sessionId
		}, '/api/v1/account/poll-inverse-sms-loop').then(function (response) {
			if (response.success) {
				if (!response.data.pending) {
					APP.Analytics.trackEvent('Subscription', 'Add', 'With SMS');
					APP.DataTable.updateAndHideForm();
					reloadIframe();
				} else {
					window.setTimeout(function () {
						loadSmsLoop(sessionId);
					}, response.data.wait * 1000);
				}
			} else {
				showReloadButton();
				window.parent.APP.Layout.alert(response.errors._global, 'Hiba');
			}
		});
	}

	function loginCallback(data) {
		var modal = $('#login_modal');

		APP.Analytics.sendStickyTrack('Belepes');
		if (data.legacyUrl && data.teeoUrl) {
			APP.Overlay.close();
			$('#link_legacy').attr('href', data.legacyUrl);
			$('#link_teeo').attr('href', data.teeoUrl);
			modal.find('.mixed-login-modal-description').html(data.mixedLoginModalDescription);
			modal.find('.legacy-box-description').html(data.mixedLoginModalLegacyBox);
			modal.find('.teeo-box-description').html(data.mixedLoginModalTeeoBox);
			$('#login_modal').modal({
				escapeClose: false,
				clickClose: false,
				showClose: false
			});
		} else if (data.redirectUrl) {
			document.location.href = data.redirectUrl;
		}
	}

	exports = {
		init: init,
		open: open,
		display1TpError: display1TpError,
		loginCallback: loginCallback
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
